module.exports = __webpack_public_path__ + "img/lt.7e7110b6.svg";